<template>
  <div>
    <label class="mt-3 mb-2 inline-block">Rubriek:</label>
    <v-select v-model="selected" :options="options" label="name" @input="$emit('input', selected)" class="" :class="error ? 'border border-red-600 rounded' : ''">
      <template v-slot:option="option">
        <div class="truncate">
          {{ option.name }}
        </div>
      </template>
    </v-select>
    <div v-if="error" class="form-error">{{ error[0] }}</div>

  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  inheritAttrs: false,
  props: {
    value: Object,
    options: Array,
    error: Array
  },
  data() {
    return {
      selected: this.value
    };
  },
  components: {
    vSelect
  },
  methods: {}
};
</script>
